module.exports = __webpack_public_path__ + "img/bg5.ccb81a5e.jpg";